import { OverlayWithText } from 'components/atoms/OverlayLoading'
import PublicRolePlayInteractionCard from 'components/molecules/rolePlay/PublicRolePlayInteractionCard'
import RolePlayInteractionCard from 'components/molecules/rolePlay/RolePlayInteractionCard'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ROLE_PLAY_TYPES } from 'services/constants'
import { getRolePlayResponse } from 'services/rolePlayServices'
import { useLocation } from 'react-router-dom'
import { trackEvent } from 'services/amplitudeTracking'
import PublicRolePlayLimitReached from 'components/molecules/rolePlay/PublicRolePlayLimitReached'
import RolePlayCompletedPopup from 'components/molecules/rolePlay/RolePlayCompletedPopup'
import RTVICall from 'components/molecules/rolePlay/RTVICall'
import { useTheme } from '@mui/material'

const CallInteractionCard = ({ children, isPublicRolePlay, ...props }) => (
  <>
    {!isPublicRolePlay ? (
      <RolePlayInteractionCard {...props}>{children}</RolePlayInteractionCard>
    ) : (
      <PublicRolePlayInteractionCard {...props}>
        {children}
      </PublicRolePlayInteractionCard>
    )}
  </>
)

const RolePlayRTVICall = ({
  rolePlay,
  notes,
  started,
  setStarted,
  completed,
  setCompleted,
  setUserCompletedRolePlay = () => {},
  setActiveUserRolePlayId = () => {},
  isPublicRolePlay
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  const theme = useTheme()
  const [completeLoading, setCompleteLoading] = useState(false)
  const [limitReached, setLimitReached] = useState(false)
  const [completedRolePlay, setCompletedRolePlay] = useState(null)
  const [completeDialogOpen, setCompleteDialogOpen] = useState(false)
  const [client, setClient] = useState(null)

  const handleCompletion = async (messages, length) => {
    setCompleteLoading(true)
    const res = await getRolePlayResponse(
      rolePlay.id,
      isPublicRolePlay,
      true,
      messages,
      length,
      notes,
      ROLE_PLAY_TYPES.LIVE_CALL
    )
    trackEvent('Complete Role Play', {
      title: rolePlay.title,
      type: 'call',
      lengthMinutes: length / 60,
      location: location.pathname
    })
    if (res.status === 200) {
      setCompletedRolePlay(res.data.data?.userRolePlay)
      setUserCompletedRolePlay({
        response: res.data.data,
        rolePlayId: rolePlay.id,
        conversationSeconds: length,
        type: ROLE_PLAY_TYPES.LIVE_CALL,
        rolePlayMessages: messages
      })
      setCompleted(true)
      setStarted(false)
      setCompleteDialogOpen(true)
    } else if (res.status === 429) {
      setLimitReached(true)
    }
    setCompleteLoading(false)
  }
  return (
    <>
      <CallInteractionCard
        isPublicRolePlay={isPublicRolePlay}
        rolePlay={rolePlay}
        buttonText={
          completed
            ? t('rolePlay.thisCallEnded')
            : started
              ? undefined
              : t('rolePlay.startLiveCall')
        }
        onButtonClick={() => {
          !started && setStarted(true)
        }}
        btnProps={{
          disabled: completed,
          sx: { '&:disabled': { color: theme.palette.primary.main } }
        }}
        completeTime={
          completed ? completedRolePlay?.conversationSeconds : undefined
        }
        showAudioIcon={started && !completed && !completeLoading}
        callClient={client}
        type={ROLE_PLAY_TYPES.LIVE_CALL}>
        {started && !completed && !completeLoading && (
          <RTVICall
            isPublicRolePlay={isPublicRolePlay}
            rolePlay={rolePlay}
            started={started}
            setStarted={setStarted}
            handleCompletion={handleCompletion}
            client={client}
            setClient={setClient}
          />
        )}
      </CallInteractionCard>
      <OverlayWithText
        isOpen={completeLoading}
        title={t('rolePlay.generatingResults')}
        message={t('rolePlay.holdTight')}
      />
      <RolePlayCompletedPopup
        open={completeDialogOpen}
        handleClose={() => setCompleteDialogOpen(false)}
        handleReview={() => setActiveUserRolePlayId(completedRolePlay?.id)}
        rolePlay={rolePlay}
      />
      {isPublicRolePlay && (
        <PublicRolePlayLimitReached
          open={limitReached}
          setOpen={setLimitReached}
        />
      )}
    </>
  )
}

export default RolePlayRTVICall
